import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormAsset,
  BackendMutationCreateLongFormAssetArgs,
} from 'src/types/backend';

import { FRAGMENT_LONG_FORM_ASSET_FULL } from './schema';

const MUTATION = gql`
  mutation CreateLongFormAsset(
    $assetGroupId: ID!
    $afterLongFormAssetId: ID
    $assetType: AssetTypeEnum!
    $generationTool: GenerationToolEnum
    $name: String!
  ) {
    createLongFormAsset(
      assetGroupId: $assetGroupId
      afterLongFormAssetId: $afterLongFormAssetId
      assetType: $assetType
      generationTool: $generationTool
      name: $name
    ) {
      ...LongFormAssetFull
    }
  }
  ${FRAGMENT_LONG_FORM_ASSET_FULL}
`;

export const createLongFormAsset = async (
  variables: BackendMutationCreateLongFormAssetArgs
): Promise<BackendLongFormAsset | undefined> => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<BackendLongFormAsset>(response.data);
};
